import React from 'react';
import { Button, Typography, Collapse } from 'components';
import { ArrowLeftIcon } from 'components/common/icons/ArrowLeftIcon';
import { ArrowBottomIcon } from 'components/common/icons/ArrowBottomIcon';
import { usePossibleOrders } from './usePossibleOrders';
import styles from './styles.module.scss';

const { Title, Text } = Typography;

export const PossibleOrders: React.FC = () => {
  const { possibleOrders, handleSelectOrder, handleBack } = usePossibleOrders();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button type="text" icon={<ArrowLeftIcon />} onClick={handleBack} className={styles.backButton} />
        <Title level={4} className={styles.title}>
          Possible Orders
        </Title>
      </div>

      <div className={styles.content}>
        <div className={styles.ordersList}>
          {possibleOrders.map((order) => (
            <div key={order.id} className={styles.orderCard}>
              <Collapse
                ghost
                expandIconPosition="end"
                className={styles.collapse}
                expandIcon={({ isActive }) => (
                  <div
                    className={styles.expandIconWrapper}
                    style={{ transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)' }}
                  >
                    <ArrowBottomIcon />
                  </div>
                )}
                items={[
                  {
                    key: order.id,
                    label: (
                      <div className={styles.orderHeaderSimple}>
                        <Text className={styles.orderNumber}>Order Number: {order.uuid}</Text>
                        <Text className={styles.supplierName}>Supplier: {order.supplier?.name}</Text>
                      </div>
                    ),
                    children: (
                      <div className={styles.orderDetails}>
                        {order.itemsResponseList && order.itemsResponseList.length > 0 && (
                          <div className={styles.itemsList}>
                            {order.itemsResponseList.map((item, index) => (
                              <div key={item.id || index} className={styles.itemRow}>
                                <Text className={styles.itemSku}>{item.sku}</Text>
                                <Text className={styles.itemQuantity}>{item.quantity} pcs</Text>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ),
                  },
                ]}
              />
              <div className={styles.buttonWrapper}>
                <Button
                  type="default"
                  size="large"
                  onClick={() => handleSelectOrder(order)}
                  className={styles.selectButton}
                  block
                >
                  Select Order
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
